"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Other(_ref) {
  var i18n = _ref.i18n,
      items = _ref.items;

  // TODO: what sould be displayed when no other informations?
  return _react2.default.createElement(
    "div",
    null,
    items.breakfast || items.dinner ? _react2.default.createElement(
      "div",
      { className: "other-info" },
      _react2.default.createElement(
        "div",
        { className: "title-box" },
        _react2.default.createElement(
          "h3",
          null,
          i18n.hotelInformation.placeToEat
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "content-box" },
        _react2.default.createElement(
          "ul",
          { className: "meal-list" },
          items.breakfast && _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              "dl",
              null,
              _react2.default.createElement(
                "dt",
                null,
                i18n.hotelInformation.breakfast
              ),
              _react2.default.createElement(
                "dd",
                null,
                items.breakfast
              )
            )
          ),
          items.dinner && _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              "dl",
              null,
              _react2.default.createElement(
                "dt",
                null,
                i18n.hotelInformation.dinner
              ),
              _react2.default.createElement(
                "dd",
                null,
                items.dinner
              )
            )
          )
        )
      )
    ) : null,
    items.bathroom && items.bathroom.length > 0 ? _react2.default.createElement(
      "div",
      { className: "other-info" },
      _react2.default.createElement(
        "div",
        { className: "title-box" },
        _react2.default.createElement(
          "h3",
          null,
          i18n.hotelInformation.bathroom
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "content-box" },
        _react2.default.createElement(
          "div",
          { className: "other-info-listbox" },
          _react2.default.createElement(
            "ul",
            null,
            items.bathroom.map(function (item) {
              return _react2.default.createElement(
                "li",
                { key: item },
                item
              );
            })
          )
        )
      )
    ) : null
  );
} // Other

Other.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  items: _react.PropTypes.object.isRequired
};

exports.default = Other;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/Other.js
// module id = 1210
// module chunks = 0